export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";

export const SUBMIT_FEEDSTOCK_TRADING_FEEDBACK = "SUBMIT_FEEDSTOCK_TRADING_FEEDBACK";
export const SUBMIT_FEEDSTOCK_TRADING_FEEDBACK_SUCCESS = "SUBMIT_FEEDSTOCK_TRADING_FEEDBACK_SUCCESS";
export const SUBMIT_FEEDSTOCK_TRADING_FEEDBACK_ERROR = "SUBMIT_FEEDSTOCK_TRADING_FEEDBACK_ERROR";

export const SET_FEEDSTOCK_TRADING_FEEDBACK_DATA = "SET_FEEDSTOCK_TRADING_FEEDBACK_DATA ";
export const CLEAR_FEEDSTOCK_TRADING_FEEDBACK_DATA =
  "CLEAR_FEEDSTOCK_TRADING_FEEDBACK_DATA";

export const RESET_FEEDSTOCK_TRADING_FEEDBACK_SUBMISISON =
  "RESET_FEEDSTOCK_TRADING_FEEDBACK_SUBMISISON";


export const OPEN_FEEDSTOCK_TRADING_TABLE_MODAL =
  "OPEN_FEEDSTOCK_TRADING_TABLE_MODAL";
export const CLOSE_FEEDSTOCK_TRADING_TABLE_MODAL =
  "CLOSE_FEEDSTOCK_TRADING_TABLE_MODAL ";

export const SHOW_FEEDSTOCK_TRADING_FEEDBACK_DETAILS =
  "SHOW_FEEDSTOCK_TRADING_FEEDBACK_DETAILS";
export const HIDE_FEEDSTOCK_TRADING_FEEDBACK_DETAILS = "HIDE_FEEDSTOCK_TRADING_FEEDBACK_DETAILS";